import {
  BehaviorSubject,
  Observable,
  Observer
} from 'rxjs';
import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';

import { Injectable } from '@angular/core';
import { MediaQueryService } from '../media-query';
import { PUBLIC_ROUTE } from 'src/app/constants/routes.constants';
import { Router } from '@angular/router';
import { Token } from '../token/index';
import { URL } from '../../constants/urls.constants'
import { UserProfileModel } from 'src/app/models/user-models/user.profile.model';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  isProfileLoaded = false;
  userType: string;
  deviceId: string = `${window.navigator.userAgent.replace(/[^a-zA-Z0-9 ]/g, '')}-${this.$mediaQuery.device}`;
  public $profile: BehaviorSubject<any> = new BehaviorSubject(null);
  readonly changes: Observable<UserProfileModel> = this.$profile.asObservable();
  profileData: UserProfileModel;
  constructor(
    private $http: HttpClient,
    private $token: Token,
    private $router: Router,
    private $mediaQuery:MediaQueryService
  ) { }
  queryProfile(): Observable<void> {
    return new Observable((observer: Observer<void>) => {
      if (this.$token.hasValue) {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.$token.value}`);
        const storedUserId = localStorage.getItem('_uid');
        const options: any = { headers };
        if (storedUserId) {
          options.params = { id: storedUserId };
        }
        this.$http.get<any>(URL.usersProfile, options).subscribe((resp: any) => {
          this.isProfileLoaded = true;
          this.$profile.next(resp.data);
          this.profileData = resp.data;
          // this.$router.navigateByUrl(LAYOUT_ROUTE.url);
          this.userType = resp && resp.data ? resp.data.userType : '';
          observer.next(resp.data);
          observer.complete();
        }, () => {
          this.isProfileLoaded = true;
          observer.next(null);
          observer.complete();
        });
      } else {
        this.next(null);
        this.isProfileLoaded = true;
        observer.next(this.$profile.getValue());
        observer.complete();
      }
    });
  }
  next(value) {
    this.profileData = value;
    this.$profile.next(value);
  }
  logout() {
    this.next(null);
    localStorage.removeItem(environment.tokenKey);
    this.$router.navigateByUrl(PUBLIC_ROUTE.url);
  }

  loggedUserType(): Observable<string> {
    return this.changes.pipe(map(data => (data && data.userType) ? data.userType : ''));
  }


  listenChanges() {
    this.changes.subscribe(
      data => {
        this.profileData = data;
      }
    )
  }
}
